import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MenuDetailPage } from 'src/app/menu/menu-detail/menu-detail.page';
import { ConfigService } from 'src/app/provider/config.service';

@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
})
export class MenuItemComponent implements OnInit {
  private _color?: string;
  private _selectedColor?: string;
  private _Tcolor?: string;
  private _selectedTColor?: string;

//  item: any;
  @Input() buttonText?: string;

  @Input() iconSrc?: string;
  storeData: any;
  @Input() isForceFixedMenu: boolean = false;
  @Input() is_variable_carbs: boolean;
    @Input() item: any;
  settings: any;
 

   @Input() typeFood: any | undefined; 

  @Input() disabled: boolean = false;
  @Input() isActive: boolean = false;


  @Output() buttonClick = new EventEmitter<void>();
  @Output() minusClickEvent = new EventEmitter<any>(); // Emit the item object

  // --- NEW: Output for the plusClick event ---
  @Output() plusClickEvent = new EventEmitter<{item: any, typeFood?: any}>(); // Emit item and typeFood

  // --- NEW: Output for menuDetailPage event ---
  @Output() menuDetailEvent = new EventEmitter<any>();

  @Output() menuConditionEvent = new EventEmitter<any>();

  // --- NEW: Output for selectFoodMenu event ---
  @Output() selectFoodMenuEvent = new EventEmitter<{item: any, typeFood: any}>();

  // --- NEW: Output for selectCarb event ---
  @Output() selectCarbEvent = new EventEmitter<{carbs: any, item: any}>();
  appL: any;



  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private configService: ConfigService,
  ) {
        this.configService.getAppSettings().then((settingData: any) => {
      this.settings = JSON.parse(settingData);
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
      this.appL = this.settings.appLanguage;
    });
//       this.item = {
//     "id": 26003,
//     "menu_builder_id": 1573852,
//     "food_type_category": "meal",
//     "food_type_id": 289,
//     "slug": "4A2B8",
//     "name": "Tofu Omelette",
//     "a_name": "أومليتا",
//     "description": "A vegetable omelette made with eggs, bell peppers, onions, and tomatoes.",
//     "a_description": "عجة نباتية مصنوعة من البيض والفلفل الحلو والبصل والطماطم.",
//     "maximum_selection_limit": 99999,
//     "scaled_protein": 150,
//     "scaled_carbs": 100,
//     "display_order": 0,
//     "protein": "22.50",
//     "calories": "450.00",
//     "fats": "18.00",
//     "carbs": "30.00",
//     "fiber": "6.75",
//     "attachment": "https://assets.dietmaster.fit/uploads/menu_items/e90e91efaf507523e3cd4dbb7aed1e1c7d634886.png",
//     "is_active": true,
//     "is_selected": true,
//     "selected_menu_item_id": 0,
//     "quantity": 0,
//     "selection_number": 0,
//     "rating": 0,
//     "my_rating": 0,
//     "comment": "",
//     "is_rating_given": false,
//     "recipe_text": "Ingredients:\r\n\r\n3 eggs, beaten\r\n1/4 cup bell peppers, diced\r\n1/4 cup mushrooms, sliced\r\n1/4 cup spinach\r\nSalt and pepper to taste\r\nInstructions:\r\n\r\nSauté vegetables in a non-stick pan until softened.\r\nPour in beaten eggs and cook until set.\r\nFold omelette in half and serve warm.",
//     "recipes": [],
//     "show_confirmation_popup": false,
//     "replaceable_menu_items": [],
//     "is_customizations_available": 0,
//     "customizations": [],
//     "active_index": 0,
//     "is_alert_confirm": false,
//     "is_children_selected": false,
//     "is_replaceable_item": false,
//     "carbs_array": [
//         0,
//         25,
//         50,
//         75,
//         100,
//         125,
//         150,
//         175,
//         200,
//         225,
//         250,
//         275,
//         300
//     ],
//     "carb_index": 4
// };
  }
  async ngOnInit() { 
    // console.log(this.item)
  }

  menuConditionCheck(){
    this.menuConditionEvent.emit(this.item);
  }

  async onButtonClick() {
    if (this.disabled==false){
    this.buttonClick.emit(); 
    }
  }
  onMinusClick() {
    // Emit the item object to the parent
    this.minusClickEvent.emit(this.item);
  }

  onPlusClick() {
    this.plusClickEvent.emit({ item: this.item, typeFood: this.typeFood });
  }
  onMenuDetailPage() {
    this.menuDetailEvent.emit(this.item);
  }
  onSelectFoodMenu() {
    this.selectFoodMenuEvent.emit({ item: this.item, typeFood: this.typeFood });
  }

  onSelectCarb(carbs: any, item: any) {
    this.selectCarbEvent.emit({ carbs, item });
  }

     menuDetailPage = async (menu: any) => {
      //  this.storeData = await this.configService.getStorage("appPayload");
    this.modalCtrl
      .create({
        component: MenuDetailPage,

        componentProps: {
          menu: menu,
          show_actual_recipes: this.storeData.show_actual_recipes,
        },
      })
      .then((model) => {
        model.present();
        model.onWillDismiss().then((data: any) => {});
      });
  }
    getShortTitle = (data: string) => {
    if (data.length > 200) {
      return data.substring(0, 39) + "...";
    }
    return data;
  }
  getShortDesc = (data: string) => {
    if (data.length > 500) {
      return data.substring(0, 49) + "...";
    }
    return data;
  }
    getParseFloat = (num: any) => {
    return Number(parseFloat(num).toFixed(0));
  }
  carbclass(carbs: any, item: any): string {
    const index = item.carbs_array.indexOf(carbs);
    const lastIndex = item.carbs_array.length - 1;

    if (item.scaled_carbs == carbs && index === lastIndex) {
      return "selectedcarb lastcarb";
    } else if (item.scaled_carbs == carbs && index === lastIndex - 1) {
      return "selectedcarb secondlastcarb";
    } else if (item.scaled_carbs == carbs && index === lastIndex - 2) {
      return "selectedcarb enditem";
    } else if (
      index === lastIndex - 3 &&
      (item.scaled_carbs == item.carbs_array[lastIndex - 2] || item.scaled_carbs == item.carbs_array[lastIndex - 1] || item.scaled_carbs == item.carbs_array[lastIndex])
    ) {
      return "enditemtop";
    } else if (index === lastIndex) {
      return "lastcarb";
    } else if (index === lastIndex - 1) {
      return "secondlastcarb";
    } else if (index === lastIndex - 2) {
      return "enditem";
    } else if (index === 0) {
      return "firstitem";
    } else if (item.scaled_carbs == carbs) {
      return "selectedcarb";
    } else if (carbs >= item.scaled_carbs + 25 && carbs < item.scaled_carbs + 50) {
      return "secondcarb";
    } else if (carbs >= item.scaled_carbs + 50 && carbs < item.scaled_carbs + 75) {
      return "thirdcarb";
    } else if (carbs >= item.scaled_carbs + 75 && carbs < item.scaled_carbs + 100) {
      return "fourthcarb";
    } else if (index === 3) {
      return "fcarb";
    } else {
      return "remainingcarb";
    }
  }
}